/************************************************************************
 * Code to animate the stat counters when they scroll into the viewport */

// Function that actually does the counting
function countUp(targetEl, targetVal, duration, decimals) {
  if (!isFinite(targetVal)) return;

  const start = 0;
  const end = targetVal;

  // Use global performance API for more consistent time-based functionality
  const startTime = performance.now();

  /**
     * Custom ease-out function for number count animation
     * Expanded form for reference:
        function easeOutCubic(t) {
            // (Optionally clamp t into [0, 1] to be safe)
            // t = Math.min(1, Math.max(0, t));

            const inv = 1 - t;
            const decelCurve = inv * inv * inv; // (1 - t)^3 == (1 - t) ** 3 == Math.pow(1 - t, 3)
            return 1 - decelCurve;              // 1 - (1 - t)^3
        }
    */
  // Actual implementation we use:
  const easeOutCubic = (t) => 1 - (1 - t) ** 3;

  const tick = (now) => {
    const t = Math.min(1, (now - startTime) / duration);
    const value = start + (end - start) * easeOutCubic(t);
    targetEl.textContent = value.toFixed(decimals);
    if (t < 1) {
      requestAnimationFrame(tick);
    } else {
      targetEl.textContent = end.toFixed(decimals);
    }
  };

  requestAnimationFrame(tick);
}

// Code to determine if the counter is in the user's viewport
const counters = document.querySelectorAll(
  ".three-column-content .stat-counter"
);
const seen = new WeakSet(); // Used to automate "garbage collection" as code should only run once

if ("IntersectionObserver" in window) {
  const io = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !seen.has(entry.target)) {
          seen.add(entry.target); // ensure it only runs once
          const targetNumber = entry.target.getAttribute("data-target-number");
          const targetEl = entry.target.querySelector("span.number");
          const decimals = (targetNumber.split(".")[1] || "").length;

          countUp(targetEl, parseFloat(targetNumber), 1000, decimals);
          obs.unobserve(entry.target); // stop tracking this one
        }
      });
    },
    {
      threshold: 0.2, // ~20% visible before starting
      rootMargin: "0px 0px -5% 0px", // start a bit before counter is fully in view
    }
  );

  counters.forEach((el) => io.observe(el));
} else {
  // Fallback for very old browsers runs on page load
  counters.forEach((counter) => {
    const targetNumber = counter.getAttribute("data-target-number");
    const targetEl = counter.querySelector("span.number");
    const decimals = (targetNumber.split(".")[1] || "").length;
    countUp(targetEl, parseFloat(targetNumber), 1000, decimals);
  });
}

/************************************************************************
 * Code to make timelines opaque when they scroll into the viewport */

(function () {
  // Collect all timelines (supports multiple instances on the page)
  var sections = document.querySelectorAll(".scrolling-timeline.page-block");
  if (!sections.length) return;

  // Collect all items from all sections
  var items = [];
  sections.forEach(function (section) {
    items.push.apply(
      items,
      section.querySelectorAll(".timeline .timeline-item")
    );
  });
  if (!items.length) return;

  // Prefer IntersectionObserver if available
  if ("IntersectionObserver" in window) {
    // rootMargin: cut 25% off the bottom of the viewport,
    // so "visible" means within the top 75% of the viewport
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-opaque");
          } else {
            entry.target.classList.remove("is-opaque");
          }
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -25% 0px",
        threshold: 0,
      }
    );

    items.forEach(function (el) {
      io.observe(el);
    });
  } else {
    // Fallback: rAF-throttled scroll/resize (works for many items too)
    var ticking = false;

    function checkAll() {
      var viewportH =
        window.innerHeight || document.documentElement.clientHeight;
      var activationY = viewportH * 0.75;

      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var onScreen = r.bottom >= 0 && r.top <= viewportH;
        if (onScreen && r.top <= activationY) {
          el.classList.add("is-opaque");
        } else {
          el.classList.remove("is-opaque");
        }
      });
    }

    function onScrollOrResize() {
      if (!ticking) {
        requestAnimationFrame(function () {
          checkAll();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    checkAll(); // initial pass
  }
})();

/**
 * Mobile overlay + accordion, with click-bubbling guard.
 * - Only toggles on mobile (<= lg)
 * - Stops clicks inside the blue overlay from bubbling to document-level handlers
 * - Keeps leaf links navigable
 */
document.addEventListener("DOMContentLoaded", function () {
  var BREAKPOINT = "(max-width: 991.98px)"; // match your lg
  var mq = window.matchMedia(BREAKPOINT);
  var isMobile = function () {
    return mq.matches;
  };

  var overlay = document.querySelector(".adapting-menu");
  var openBtn = document.querySelector(".mobile-nav-open");
  var closeBtn = document.querySelector(".mobile-nav-close");
  var menu = document.getElementById("primary-menu");

  if (!overlay || !menu) return;
  /**
   * Mobile sub-menu functionality
   */
  const menuParentItems = [...menu.querySelectorAll(':scope > .menu-item-has-children svg')];
  const openClass = 'menu-item-has-children--open';

  const toggleItemClass = (clickedItem) => {
    menuParentItems.forEach((item) => {
      let itemParent = item.closest('.menu-item-has-children');
      let itemSubMenu = itemParent.querySelector('.sub-menu');

      if (clickedItem === item) {
        itemParent.classList.toggle(openClass);

        if (itemSubMenu.style.height) {
          itemSubMenu.style.height = '';
        } else {
          itemSubMenu.style.height = itemSubMenu.scrollHeight + 'px';
        }
      } else {
        itemParent.classList.remove(openClass);
        itemSubMenu.style.height = '';
      }
    });
  }
  menuParentItems.forEach((item) => {
    const parent = item.closest('.menu-item-has-children');
    const subMenu = parent.querySelector('.sub-menu');
    const mobileWidth = 991.99;
    let parentBounds;
    let subMenuBounds;

    item.addEventListener('click', (e) => {
      if (window.innerWidth <= mobileWidth) {
        e.preventDefault();
      }
      toggleItemClass(item);
    });

    item.addEventListener('mouseover', (e) => {
      if (window.innerWidth > mobileWidth) {
        parentBounds = parent.getBoundingClientRect();
        subMenuBounds = subMenu.getBoundingClientRect();
        subMenu.style.top = parentBounds.bottom + "px";
        subMenu.classList.add('sub-menu--show');

        if ((subMenuBounds.left + subMenuBounds.width) < (parentBounds.left + parentBounds.width)) {
          subMenu.style.left = (parentBounds.left + parentBounds.width) - (subMenuBounds.width) + "px";
          subMenu.style.transform = "translateX(0)";
        }
      }
    });
    [subMenu, parent].forEach((ele) => {
      ele.addEventListener('mouseleave', (e) => {
        if (window.innerWidth > mobileWidth) {
          subMenu.style = '';
          subMenu.classList.remove('sub-menu--show');
        }
      })
    });
  });
  /* ---------- open / close overlay ---------- */
  function openOverlay() {
    overlay.classList.add("active");
    overlay.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  }
  function closeOverlay() {
    overlay.classList.remove("active");
    overlay.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    // collapse all submenus
    menu.querySelectorAll(".is-open").forEach(function (li) {
      li.classList.remove("is-open");
    });
  }
  if (openBtn) openBtn.addEventListener("click", openOverlay);
  if (closeBtn) closeBtn.addEventListener("click", closeOverlay);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeOverlay();
  });

  /* ---------- STOP BUBBLING inside the blue overlay ---------- */
  // Many themes/plugins attach document-level click handlers that close menus.
  // We intercept clicks/touches inside the overlay so they don't bubble up.
  ["click", "touchstart"].forEach(function (evt) {
    overlay.addEventListener(
      evt,
      function (e) {
        if (!isMobile()) return;
        // allow the explicit close button to work
        if (e.target.closest(".mobile-nav-close")) return;
        // allow leaf links to navigate normally
        if (
          e.target.closest(
            "#primary-menu .menu-item:not(.menu-item-has-children) a"
          )
        )
          return;
        //e.stopPropagation(); // <-- key line
      },
      true
    ); // capture so we win before document handlers
  });

  /* ---------- accordion toggle on parent links (mobile only) ---------- */
  menu.addEventListener("click", function (e) {
    var a = e.target.closest("a");
    if (!a) return;

    var li = a.closest("li");
    if (!li) return;

    // Desktop: do nothing; CSS hover handles it
    if (!isMobile()) return;

    var isParent = li.classList.contains("menu-item-has-children");

    if (isParent) {
      // First tap opens, second tap closes
      //e.preventDefault();
      var willOpen = !li.classList.contains("is-open");
      li.classList.toggle("is-open");

      // Accordion: close siblings when opening a new one
      if (willOpen) {
        Array.from(li.parentElement.children).forEach(function (sib) {
          if (sib !== li) sib.classList.remove("is-open");
        });
      }
    } else {
      // Leaf link: navigate, but optionally close overlay first
      // closeOverlay(); // uncomment if you want overlay to close on navigation tap
    }
  });

  /* ---------- clean up if viewport crosses breakpoint ---------- */
  mq.addEventListener("change", function () {
    document.body.style.overflow = "";
    overlay.classList.remove("active");
    overlay.setAttribute("aria-expanded", "false");
    menu.querySelectorAll(".is-open").forEach(function (li) {
      li.classList.remove("is-open");
    });
  });
});
